// Entry point bundled by esbuild (jsbundling-rails). Everything here is a real
// npm dependency — no CDN <script> tags anywhere in the layouts.
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// RBAC admin screens (roles, features, permissions): client-side list tables,
// create/edit and delete modals, permission tree. Re-wired on every Turbo visit;
// each init skips what it has already wired.
import { initTableLists, initFormModals, initDeleteModals } from "./rbac/table_list"
import { initPermissionTrees } from "./rbac/permission_tree"

document.addEventListener("turbo:load", () => {
  initTableLists()
  initPermissionTrees()
  initFormModals(bootstrap.Modal)
  initDeleteModals(bootstrap.Modal)
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => bootstrap.Tooltip.getOrCreateInstance(el))
})
